import { render, staticRenderFns } from "./RevertMatch.vue?vue&type=template&id=ec922f10"
import script from "./RevertMatch.vue?vue&type=script&lang=js"
export * from "./RevertMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports